import { css } from '@lastbrand/web-ui-styled-system/css'

// Full DS styling for the option-group legend, used INSTEAD OF the legacy `.container__label`
// on the DS path (no unlayered legacy rule to fight → no !important needed).
export const labelDsClass = css({
  // legacy desktop label measures 13.33px / 20px line-height (1.2rem / 1.8rem at the capped 11.11px
  // fluid root); body-14 (14px / 20px bundled) is the closest token on both axes.
  textStyle: 'body-14',
  fontWeight: 500,
  color: 'black',
  display: 'flex',
  width: '100%',
  justifyContent: { base: 'space-between', lg: 'flex-start' },
  gap: { lg: 'space-4' },
})

// Option-group layout on the DS path, used INSTEAD OF the legacy `.container__options` so the
// legend->options gap and group->group spacing follow DS tokens (space-12 / space-24).
export const optionGroupDsClass = css({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 'space-24',
})

// Legend inner spans. Legacy `.container__label__optionLabel` is `display: inline` and
// `.container__label__selectedValue` drops the label's 500 weight back to 400 for the chosen value.
export const optionLabelDsClass = css({ display: 'inline' })
export const selectedValueDsClass = css({ fontWeight: 400 })

// Hurry/low-inventory message — legacy `.selected_variant_available_inventory_message` with the
// now-permanent `_newDesignV2`: red, full width, centered desktop / flex-left on mobile.
export const lowInventoryMessageDsClass = css({
  textStyle: 'body-14',
  color: 'red-100',
  textAlign: 'center',
  width: 'full',
  marginBottom: 'space-10',
  lgDown: {
    marginBottom: 'space-16', // legacy _adjustedPadding
    display: 'flex',
    alignItems: 'center',
    gap: 'space-8',
    textAlign: 'left',
    padding: 0,
  },
})

// Hurry icon: desktop-hidden, 16px on mobile (legacy parity).
export const lowInventoryIconDsClass = css({
  display: 'none',
  lgDown: { display: 'block', width: '16px', height: '16px' },
})

// Klarna pay-later wrapper (legacy `.container__szmessage`).
export const klarnaWrapperDsClass = css({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingTop: '14px', // no 14px spacing token
  paddingBottom: 'space-8',
  lineHeight: '16px',
})

// Subscription terms notice (legacy `.subscriptionTermsNotice`).
export const subscriptionTermsNoticeDsClass = css({
  textStyle: 'body-12',
  color: 'black',
  textAlign: 'left',
  marginTop: 'space-8',
})

export const subscriptionTermsNoticeLinkDsClass = css({
  textDecoration: 'underline',
  textUnderlineOffset: 'space-2',
})
